// Lib
import { createStructuredSelector } from 'reselect';

// Utils
import { getIsElectron } from '../../hybridApp/hybridAppUtils';

export default createStructuredSelector({
    isElectron: getIsElectron,
});
